import React, { useContext, useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { AppContext } from "../../../Contexts/AppContext";

const Hero = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["commerce"].bg
        : context.currentTheme["commerce"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["commerce"].text
        : context.currentTheme["commerce"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["commerce"].dropdown
        : context.currentTheme["commerce"].dark_dropdown
    );
  }, [context]);
  return (
    <div
      style={{
        backgroundColor: currentBG,
        color: currentText,
      }}
      className="flex min-h-[calc(100vh-56px)] items-stretch justify-center transition-all duration-500"
    >
      <div className="m-5 flex w-1/3 flex-col items-center justify-center xs:w-2/3 ss:m-10 sm:w-1/3">
        <h1 className="text-xl font-bold tracking-wider ss:text-2xl sm:text-3xl">
          LET US CREATE MEMORIES TOGETHER
        </h1>
        <p className="text-sm font-thin tracking-tighter ss:text-base">
          It's only the funny, cringeworthy, weird moments that get stuck in our
          minds forever.
        </p>
        <div className="mt-5 flex w-full flex-wrap items-center justify-between sm:mt-10">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="m-1 w-32 rounded border-2 border-[#ffb700] py-2 text-center text-sm transition-all ss:m-2 ss:w-36 ss:text-base"
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = currentColor;
              e.target.style.borderColor = currentText;
              e.target.style.color = currentText;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "unset";
              e.target.style.borderColor = "#ffb700";
              e.target.style.color = "unset";
            }}
          >
            VISIT US
          </a>
          <HashLink
            to="#products"
            smooth
            className="m-1 w-32 rounded border-2 border-[#ffb700] py-2 text-center text-sm transition-all ss:m-2 ss:w-36 ss:text-base"
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = currentColor;
              e.target.style.borderColor = currentText;
              e.target.style.color = currentText;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "unset";
              e.target.style.borderColor = "#ffb700";
              e.target.style.color = "unset";
            }}
          >
            PRODUCTS
          </HashLink>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <img
            src={`${process.env.REACT_APP_IMAGES_URL}/Assets/Images/E-Commerces/Tipsy/blackonwhite.png`}
            alt="tipsy mobile"
            className="ss:w-52"
          />
          <p
            className="text-sm font-semibold xs:text-base ss:text-xl sm:text-2xl"
            style={{ lineHeight: 1 }}
          >
            #TipsyMonkey2023
          </p>
          <p
            className="text-sm font-semibold ss:text-lg sm:text-xl"
            style={{ lineHeight: 1 }}
          >
            New Collection!
          </p>
        </div>
        <img
          src={`${process.env.REACT_APP_IMAGES_URL}/Assets/Images/E-Commerces/Tipsy/mobile-tipsy.png`}
          alt="tipsy mobile"
          className="mt-20 w-96 lg:mt-auto"
        />
      </div>
      <div
        style={{
          backgroundImage: `linear-gradient(to bottom, #ffb70011, #ffb70055), url('${process.env.REACT_APP_IMAGES_URL}/Assets/Images/E-Commerces/Tipsy/model1.jpg')`,
        }}
        className="m-10 hidden w-1/3 rounded-2xl bg-cover bg-no-repeat lg:block"
      ></div>
    </div>
  );
};

export default Hero;
